module.exports = __webpack_public_path__ + "3f65cb5d8c96e87d0257c7ee2f731d78.jpg";